import { useQueryClient } from '@tanstack/react-query'
import { LectureVideoInsertRequest } from '../../../types/video'
import { useApiPostMutation } from '../useApi'

export const useVideosInsert = () => {
  const queryClient = useQueryClient()
  const mutation = useApiPostMutation<LectureVideoInsertRequest>()

  const insertVideo = async (requestData: LectureVideoInsertRequest) => {
    const result = await mutation.mutateAsync({
      url: '/lectures/videos/insert',
      data: requestData,
    })

    queryClient.invalidateQueries({ queryKey: ['lecture-list'] })
    queryClient.invalidateQueries({ queryKey: ['lecturesStatus'] })
    queryClient.invalidateQueries({ queryKey: ['videosDetail'] })

    return result
  }

  return {
    insertVideo,
    isPending: mutation.isPending,
    error: mutation.error,
    isSuccess: mutation.isSuccess,
  }
}
